import { Injectable } from "@angular/core";
import { AppPreferences, Preference } from "../../shared/local/app-preferences.local";
import { RequestSubmitTrackPolicyDto } from "../../shared/nestjs/gd-integrated/dto/policy.dto";
import { SF6SPolicyApi } from "../../shared/nestjs/gd-integrated/services/sf6s-policy.api";
import { PolicyApi } from "../../shared/nestjs/gd-only/services/policy.api";
import { ResponseCheckPolling } from "../feature/home/home.dto";

@Injectable()
export class PolicyBloc {


  constructor(
    private sf6sPolicyApi: SF6SPolicyApi,
    private policyApi: PolicyApi,
    private appPreferences: AppPreferences,
  ) {

  }

  getTrackPolicy() {
    return new Promise<ResponseCheckPolling>(async (resolve) => {
      const result: ResponseCheckPolling = {
        page: '',
        params: null,
        restrict: false
      };

      const SFGoAuth = await this.appPreferences.getAuth();
      if (SFGoAuth.isSF6) {
        const resPolicy = await this.sf6sPolicyApi.trackPolicy()
          .toPromise()
          .catch();

        if (resPolicy.data.length > 0) {
          result.page = 'TrackPolicyPage';
          result.params = resPolicy.data;
        }
      } else {
        const resPolicy = await this.policyApi.getTrackPolicy({ limit: 50, page: 1 })
          .map(res => res.data)
          .toPromise()
          .catch();

        const hasSubmit = await this.appPreferences.getGreatdayStorage(Preference.PolicySubmit);
        if (resPolicy.length > 0 && !hasSubmit) {
          result.page = 'PrivacyPolicyPage';
          result.params = resPolicy[0];
        }
      }

      resolve(result);
    });
  }

  submitTrackPolicy(payload: RequestSubmitTrackPolicyDto[]) {
    return this.policyApi.submitTrackPolicy(payload).toPromise();
  }

}


// WEBPACK FOOTER //
// ./src/bloc/company/policy.bloc.ts